/**
 * activateGenericModal.tsx
 */
import Container from '@components/atoms/container/modalContainer';
import Buttons from '@components/elements/modal/activateModalButtons';
import FlavourConfig from '@shared/config/flavours';
import Logo from '@components/atoms/images/modalLogo';
import QR from '@components/atoms/images/activateModalQr';
import Subtitle from '@components/atoms/text/modalSubtitle';
import Title from '@components/atoms/text/modalTitle';
import TranslationManager from '@shared/assets/locale/translationsManager';

/**
 * Displays the activate generic modal.
 */
export default function ActivateGenericModal() {
  return (
    <Container>
      <Logo />
      <Title>
        {TranslationManager.get('MODAL.ACTIVATE.TITLE', FlavourConfig.appTitle)}
      </Title>
      <Subtitle>{TranslationManager.get('MODAL.ACTIVATE.SUBTITLE')}</Subtitle>
      <QR />
      <Buttons />
    </Container>
  );
}
